<template>
  <div class="d-flex flex-column gr-6">
    <div
      class="px-2"
      :class="isMobile ? 'text-h6' : 'text-h5 text-center'"
    >
      {{ t('СМИ о ПроДокторов', options) }}
    </div>

    <CoreSwiper v-if="isMobile">
      <template #slides="{ slideAttrs }">
        <div
          v-for="(media, index) in mediaList"
          :key="index"
          v-bind="slideAttrs"
        >
          <div class="d-flex flex-column elevation-1 rounded-sm mx-2">
            <div
              class="media-list__logo border-b-sm rounded-t-sm"
              :class="media.logoClass"
            />
            <div class="d-flex flex-column gr-4 pa-4 text-center">
              <div class="text-subtitle-1 text--text">
                {{ media.title }}
              </div>
              <div class="text-body-2 text-secondary--text">
                «{{ media.text }}...»
              </div>
            </div>
          </div>
        </div>
      </template>
    </CoreSwiper>
    <div
      v-else
      class="media-list"
    >
      <div
        v-for="(media, index) in mediaList"
        :key="index"
        class="d-flex flex-column hover-animation elevation-1 rounded-sm"
      >
        <div
          class="media-list__logo border-b-sm rounded-t-sm"
          :class="media.logoClass"
        />
        <div class="d-flex flex-column gr-4 pa-4 text-center">
          <div class="text-subtitle-1 text--text">
            {{ media.title }}
          </div>
          <div class="text-body-2 text-secondary--text">
            «{{ media.text }}...»
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/profile/doctors/register/index/types'
import useContextStore from 'src/store/useContextStore'
import CoreSwiper from 'src/core/CoreSwiper/CoreSwiper.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')

const mediaList = [
  {
    logoClass: 'media-list__logo--coms-prav',
    href: 'https://www.msk.kp.ru/daily/26881.3/3924379/',
    title: '«ПроДокторов» собрал более миллиона отзывов о врачах и клиниках',
    text: '«Самый крупный в России ресурс с рейтингом специалистов и лечебных учреждений бьет рекорды по откликам пациентов...»',
  },
  {
    logoClass: 'media-list__logo--forbes',
    href: 'https://www.forbes.ru/healthcare/534020-publicnyj-sovetnik-kak-hirurg-naucil-pacientov-pisat-otzyvy-na-vracej',
    title: 'Публичный советник: как хирург научил пациентов писать отзывы на врачей',
    text: [
      'Как хобби бывшего хирурга Краснодарской краевой больницы',
      'которое он придумал задолго до появления на рынке своих основных конкурентов — «СберЗдоровье» и «На поправку»',
      'превратилось в успешный бизнес без привлечения инвестиций и почему юристы фирмы не вылезают из судов?',
    ].join(', '),
  },
  {
    logoClass: 'media-list__logo--rg-ru',
    href: 'https://rg.ru/2025/07/30/vrachebnyj-osmotr.html',
    title: 'В России предложили создать регистр для проверки образования врачей',
    text: [
      'Минздравы регионов поддержали инициативу о проверке образования врачей и создании специального регистра для этого.',
      'Такие данные приводят сервис "МедРокет" и портал "ПроДокторов"',
    ].join(' '),
  },
]
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.hover-animation {
  transition: 0.15s ease-in-out transform;

  &:hover {
    transform: translateY(-4px);
  }
}

.media-list {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fit, minmax(296px, 1fr));

  &__logo {
    height: 85px;

    &--coms-prav {
      background: url('/static/_v1/pd/logos/lpus/komsomolskaya-pravda.png') no-repeat center, $color-branded-light-grey;
    }

    &--forbes {
      background: url('/static/_v1/pd/logos/media/forbes.png') no-repeat center / contain, #231f20;
      object-fit: contain;
    }

    &--rg-ru {
      background: url('/static/_v1/pd/logos/media/rg-ru.png') no-repeat center / contain, #fcfcfc;
    }
  }
}
</style>
